import * as React from "react";
import {Field, InjectedFormProps, reduxForm} from "redux-form";
import {renderCheckbox, RenderUserAttributeCheckbox, RenderUserAttributesField} from "./form";
import {Dispatch} from "redux";
import {updateUserDetails} from "../UserActions";
import {AppState} from "../../RootReducer";
import { connect, useSelector } from "react-redux";
import { Currency, CurrencyDefinition, UserAttributeDefinition, UserWriteAccess } from "../../http/protocol";
import { getFiatExchangeCurrencies, getIsMayaMiniAppContext, getPreferredFiatExchange } from "../../selectors/settings-selectors";
import { t } from "../../i18n";
import { Checkbox } from "../../ui/notifications/NotificationsComponent";

interface Props extends InjectedFormProps {
  requiredAttributes?: UserAttributeDefinition[];
  userAttributes?: { [index: string]: string };
  currencies?: Currency[];
  iconSubmitButton?: boolean;
  fiatCurrencies?: string[];
}

export const ProfilePreferCurrencyForm = (props: Props) => {
  const { handleSubmit, pristine, reset, submitting, asyncValidating, error } = props;
  const isMayaMiniApp = useSelector(getIsMayaMiniAppContext);
  let currencyList: string[] = [];
  props.currencies &&
    props.currencies.map((curr) => {
      curr.code && currencyList.push(curr.code);
    });
  console.log("Fiat currencies = ", props.fiatCurrencies);
  console.log("User attributes = ", props.userAttributes);
  let fiatCurrencyList: string[] = props.fiatCurrencies ?? [];
  return (
    <form className="form register-form crypto-to-fiat-exchange" onSubmit={handleSubmit}>
      <div className={"row account-page-row compact"}>
        <div className={"col-md-6"}>
          <label>{t("profile.preferCurrencyTitle")}:</label>
          <span className={"help"}>{t("forms.preferredCurrency.help")}</span>
        </div>
        <div className={"col-md-6 right"}>
          {props.currencies && props.currencies.length > 1 && (
            <Field
              key={"prefCurr"}
              props={{
                label: "Preferred Currency",
                autoCorrect: "off",
                userAttributesKey: "forms.preferredCurrency.label",
                regex: "",
              }}
              value={""}
              name={"preferredCurrency"}
              pristine={true}
              maxLength={25}
              minLength={3}
              withDropdown={true}
              optionsDropdown={currencyList}
              showHelpAlways={true}
              component={RenderUserAttributesField}
              text={"preferredCurrency"}
              dropdownSelect={"dropdownSelect"}
            />
          )}
        </div>
      </div>
      <div className={"row account-page-row compact"}>
        <div className={"col-md-6"}>
          <label>{t("profile.preferCashbackCurrencyTitle")}:</label>
          <span className={"help"}>{t("forms.preferredCashbackCurrency.help")}</span>
        </div>
        <div className={"col-md-6 right"}>
          {props.currencies && props.currencies.length > 1 && (
            <Field
              key={"prefCBCurr"}
              props={{
                label: "Preferred Cashback Currency",
                autoCorrect: "off",
                userAttributesKey: "forms.preferredCashbackCurrency.label",
                regex: "",
              }}
              value={""}
              name={"preferredCashbackCurrency"}
              pristine={true}
              maxLength={25}
              minLength={3}
              withDropdown={true}
              optionsDropdown={currencyList}
              showHelpAlways={true}
              component={RenderUserAttributesField}
              text={"preferredCashbackCurrency"}
              dropdownSelect={"dropdownSelect"}
            />
          )}
        </div>
      </div>
      {props.userAttributes && props.userAttributes["preferredPokerExchangeCurrency"] && (
        <div className={"row account-page-row compact"}>
          <div className={"col-md-6"}>
            <label>{t("profile.preferPokerCurrencyTitle")}:</label>
            <span className={"help"}>{t("forms.preferredPokerCurrency.help")}</span>
          </div>
          <div className={"col-md-6 right"}>
            {props.currencies && props.currencies.length > 1 && (
              <Field
                key={"prefPokerCurr"}
                props={{
                  label: "Preferred Currency",
                  autoCorrect: "off",
                  userAttributesKey: "forms.preferredCurrency.label",
                  regex: "",
                }}
                value={""}
                name={"preferredPokerExchangeCurrency"}
                pristine={true}
                maxLength={25}
                minLength={3}
                withDropdown={true}
                optionsDropdown={currencyList}
                showHelpAlways={true}
                component={RenderUserAttributesField}
                text={"preferredPokerExchangeCurrency"}
                dropdownSelect={"dropdownSelect"}
              />
            )}
          </div>
        </div>
      )}
      {!isMayaMiniApp && (
        <div className={"row account-page-row compact"}>
          <div className={"col-md-6"}>
            <label>{t("forms.preferredFiatExchangeCurrency.title")}:</label>
            <span className={"help"}>{t("forms.preferredFiatExchangeCurrency.help")}</span>
          </div>
          <div className={"col-md-6 right"}>
            {props.fiatCurrencies && props.fiatCurrencies.length > 0 && (
              <Field
                key={"preferredFiatExchangeCurrency"}
                props={{
                  label: "Preferred Fiat Currency",
                  autoCorrect: "off",
                  userAttributesKey: "forms.preferredFiatExchangeCurrency.label",
                  regex: "",
                }}
                value={""}
                name={"preferredFiatExchangeCurrency"}
                pristine={true}
                maxLength={25}
                minLength={3}
                withDropdown={true}
                optionsDropdown={fiatCurrencyList}
                showHelpAlways={true}
                component={RenderUserAttributesField}
                text={"preferredFiatExchangeCurrency"}
                dropdownSelect={"dropdownSelect"}
              />
            )}
          </div>
        </div>
      )}
      {!isMayaMiniApp && (
        <div className="row account-page-row">
          <div className={"col-md-6"}>
            <label>{t("forms.displayFiatExchangeIfAvailable.title")}:</label>
            <span className={"help"}>{t("forms.displayFiatExchangeIfAvailable.help")}</span>
          </div>
          <div className={"col-md-6 right"}>
            <Field name={"displayFiatExchangeIfAvailable"} component={RenderUserAttributeCheckbox} />
            {/*
                    <Checkbox checked={this.state.isSubscribed} onChange={() => this.onClick()} />
                    */}
          </div>
        </div>
      )}
    </form>
  );
};

const mapStateToProps = (app: AppState) => {
    return {
        currencies: app.user?.user?.currencies,
        fiatCurrencies: getFiatExchangeCurrencies(app)
    }
}

const form = reduxForm({
    form: 'profileCurrency',
    onChange: (req: {
        preferredCurrency: string,
        preferredCashbackCurrency: string,
        preferredPokerExchangeCurrency: string,
        preferredFiatExchangeCurrency: string,
        displayFiatExchangeIfAvailable: boolean
    }, dispatch: Dispatch, props: any) => {
        console.log("onChange currency form = ", req);
        let internal: any = Object.assign({}, req);
        let attr = {};
        props.requiredAttributes && props.requiredAttributes.map((item: any) => {
            if (item.userWriteAccess == UserWriteAccess.CREATE) {
                delete internal[item.attributeKey];
            }
        })
        internal.attributes = attr;
        let updateAttributes = {...internal.attributes};
        if (props.currencies && props.currencies.length > 1 && internal.preferredCurrency != undefined) {
            updateAttributes.preferredCurrency = internal.preferredCurrency.length > 0 ? internal.preferredCurrency : null;
        }
        if (props.currencies && props.currencies.length > 1 && internal.preferredCashbackCurrency != undefined) {
            updateAttributes.preferredCashbackCurrency = internal.preferredCashbackCurrency.length > 0 ? internal.preferredCashbackCurrency : null;
        }
        if (props.currencies && props.currencies.length > 1 && internal.preferredPokerExchangeCurrency != undefined) {
            updateAttributes.preferredPokerExchangeCurrency = internal.preferredPokerExchangeCurrency.length > 0 ? internal.preferredPokerExchangeCurrency : null;
        }

        if(internal.preferredFiatExchangeCurrency && internal.preferredFiatExchangeCurrency.length > 0) {
            updateAttributes.preferredFiatExchangeCurrency =  internal.preferredFiatExchangeCurrency;
        } else {
            updateAttributes.preferredFiatExchangeCurrency =  null;
        }
        if(internal.displayFiatExchangeIfAvailable === true) {
            updateAttributes.displayFiatExchangeIfAvailable = "true";
        } else if(internal.displayFiatExchangeIfAvailable === false) {
            updateAttributes.displayFiatExchangeIfAvailable = "false";
        } else {
            updateAttributes.displayFiatExchangeIfAvailable = null;
        }
        return dispatch(updateUserDetails(updateAttributes) as any)
    },
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(ProfilePreferCurrencyForm as any);

export default connect(mapStateToProps)(form);


